import React from 'react';
import { Pagination } from 'antd';
import cn from 'classnames';
import styles from './DspxPagination.module.scss';

const DspxPagination = ({
  className,
  quickJumperToStart = false,
  ...props
}) => {
  return (
    <Pagination
      {...props}
      className={cn(styles.root, className, {
        [styles.quickJumperToStart]: quickJumperToStart,
      })}
    />
  );
};

export default DspxPagination;
